function setupRadioButtons(callback) {
  $('.checkbox').click(function() {
    $(this).prev().prop('checked', true);
    let currentVal = $(this).prev().val();
    callback(currentVal);
  })
}

const agenda = function() {
  setTimeout(function() {
    setupRadioButtons()
  }, 500)



  function setupRadioButtons(callback) {
    $('.view-selector input').unbind();
    $('.view-selector input').on('change', function() {
      let currentVal = $(this).val();
      console.log(currentVal);

      $('.agenda-group').css('opacity', 0);
      setTimeout(function() {
        $('.agenda-group').css('display', 'none');
        $(`.agenda-group.${currentVal}`).css('display', 'block');
        setTimeout(function() {
          $(`.agenda-group.${currentVal}`).css('opacity', 1);
        }, 200)
      }, 150)
    })
  }
}

export default agenda





// WEBPACK FOOTER //
// ./scripts/barba-views/agenda.js